import { Component, isDevMode } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import {PhcApp} from "../../classes/phc-app/phc-app";
import {WpProvider} from "../../providers/wp/wp";
import { App } from 'ionic-angular';
import { KioskServiceProvider } from '../../providers/kiosk-service/kiosk-service';

/**
 * Generated class for the WebpageIframePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-webpage-iframe',
  templateUrl: 'webpage-iframe.html',
})
export class WebpageIframePage {

  url: string;
  phcApp: PhcApp;

  constructor(public navCtrl: NavController, public navParams: NavParams, wp: WpProvider, private app: App, private kioskService: KioskServiceProvider) {
    this.url = this.navParams.get('url');
    this.phcApp = wp.app;
  }

  activityInterval;

  ionViewDidLoad() {
    this.activityInterval = setInterval(() => {
      this.kioskService.appActivity.next(true);
    }, 1000);
  }

  ionViewDidLeave() {
    clearInterval(this.activityInterval);
  }

}



// WEBPACK FOOTER //
// ./src/pages/webpage-iframe/webpage-iframe.ts